import Blue from "~/core";

new Blue({
	name: 'Stats Bar',
	selector: ".stats-bar",
	setup(statsBar) {
		const numberElements = [...statsBar.querySelectorAll(".stats-bar__number")];

		numberElements.forEach(el => {
			let numberString = el.innerHTML;
			const patternStr = "0123456789";
			let charArr = numberString.split("");
			let finalStr = '';
			charArr.forEach(char => {
				if (patternStr.includes(char)) {
					finalStr += "<span class='stats-bar__integers-container'><div class='stats-bar__slider'><span class='stats-bar__integer'>-</span>";
					for (let k = 0; k <= parseInt(char); k++) {
						finalStr += "<span class='stats-bar__integer'>" + k + "</span>";
					}
					finalStr += "</div></span>";
				} else {
					finalStr += char;
				}
			});
			el.innerHTML = finalStr;
		});

		let sliders = [...statsBar.querySelectorAll(".stats-bar__slider")];
		function triggerStats() {
			function setTransform(el, i) {
				setTimeout(() => {
					let intCount = el.querySelectorAll(".stats-bar__integer").length;
					let height = el.querySelector(".stats-bar__integer").getBoundingClientRect().height;
					el.style.transform = "translateY(-" + (intCount - 1) * (height) + "px)";
				}, 100 * i);
			}
			sliders.forEach((slider, index) => {
				setTransform(slider, index);
			});
		}

		function getPosition(element) {
			var yPosition = 0;
			while(element) {
					yPosition += (element.offsetTop - element.scrollTop + element.clientTop);
					element = element.offsetParent;
			}
			return yPosition
		}

		let doneWaiting = false;
		let scrolling = false;
		let scrollInterval;
		// Below variable is a way to roughly measure at what point stats-bar is visible on the page
		let statsBarPosition;
		function testForTrigger() {
			if (window.innerWidth > 620) {
				statsBarPosition = getPosition(statsBar) - (statsBar.offsetHeight * 0.5) - (window.innerHeight * 0.875);
			} else if (window.innerHeight > 800) {
				statsBarPosition = getPosition(statsBar) - (statsBar.offsetHeight * 0.5) - (window.innerHeight * .5);
			} else {
				statsBarPosition = getPosition(statsBar) - (statsBar.offsetHeight * 0.85);
			}
			if (document.documentElement.scrollTop > statsBarPosition) {
				triggerStats();
				doneWaiting = true;
			}
		}
		scrollInterval = setInterval(() => {
			if (scrolling) {
				if (doneWaiting) {
					return;
				} else {
					testForTrigger();
				}
			}
		}, 500);

		this.$addEvents(document, "scroll", (e) => {
			scrolling = true;
			if (doneWaiting) clearInterval(scrollInterval);
		});

		testForTrigger();
	}
});
